window.dtPlanningProducts = function () {
  setSessionValue()

  var table = new DataTable('#planning-products-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#planning-products-datatable').data('source'),
      data: function (d) {
        d.planning_date = $("#planning_date_dt").val()
      },
      beforeSend: function () { showLoadingRow('#planning-products-datatable', 9); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[2, 'asc'], [0, 'asc']],
    columns: [
      { "data": "index" },
      { "data": "action" },
      { "data": "line_number" },
      { "data": "product1" },
      { "data": "product2" },
      { "data": "product3" },
      { "data": "product4" },
      { "data": "product5" },
      { "data": "product6" },
    ],
    columnDefs: [
      {
        targets: "_all",
        className: "text-nowrap",
      }
    ],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
  });

  $(document).on("change", "#planning_date_dt", function(){
    table.ajax.reload()
  })
  dtFinalTouch()
}